import React from 'react';
import ilus1 from '../img/ilus1.jpeg';
import ilus2 from '../img/ilus2.jpeg';
import ilus3 from '../img/ilus3.jpeg';
import ilus4 from '../img/ilus4.jpeg';
import ilus5 from '../img/ilus5.jpeg';
import ilus6 from '../img/ilus6.jpeg';
import ilus7 from '../img/ilus7.jpeg';
import ilus8 from '../img/ilus8.jpeg';
import ilus9 from '../img/ilus9.jpeg';
import ilus10 from '../img/ilus10.jpeg';

import { Link } from 'react-router-dom';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import  {Title,Div, Click, Span, Img} from './StyleComponents';

const IlustDig = () => {
	return (
		<>
			<Link className='flecha' to={'/'}>
				&#60;{' '}
			</Link>
			<Title>Ilustración Digital</Title>
			<Click>
				La ilustración digital se envía por mail en formato jpg y pdf, en el
				tamaño requerido
			</Click>
			<AliceCarousel disableButtonsControls controlsStrategy='alternate'>
				<Img src={ilus1} className='sliderimg' />
				<Img src={ilus2} className='sliderimg' />
				<Img src={ilus3} className='sliderimg' />
				<Img src={ilus4} className='sliderimg' />
				<Img src={ilus5} className='sliderimg' />
				<Img src={ilus6} className='sliderimg' />
				<Img src={ilus7} className='sliderimg' />
				<Img src={ilus8} className='sliderimg' />
				<Img src={ilus9} className='sliderimg' />
				<Img src={ilus10} className='sliderimg' />
			</AliceCarousel>
			<Div>
				<Title>
					$15000 
				</Title>
				<Title>
					<Span>
						(Valido por dos personas)
					</Span>
				</Title>
			</Div>
		</>
	);
};

export default IlustDig;
